import $ from 'jquery';
import CombineTestReportStyle from './CombineTestReport.module.scss';
import * as React from 'react';
import { Injector, EventEmitter } from 'Core';
import { IReportDataService, IReportDataConversionService } from 'Services';
import * as Data from 'Data';
import { MultiShotHelpers } from '../Helpers/MultiShotHelpers';
import {
  ISummaryScreenControlParams,
  IOptimizerControlParams,
  IMultiShotControlParams,
  ISkidAndRollControlParams,
  ISponsorDetailsProps,
  IInstructorMessageControlProps,
  IClubControlProps,
  INormalizedCheckboxTextProps,
  IFooterWithCommercialProps,
  IVideoControlProps,
  ITrajectoryControlParams,
  IShareButtonsProps,
  SummaryScreenControl,
  IGeneralSummaryControlParams,
  SponsorDetails,
  ReportWithNoData,
  FooterWithCommercial,
  HeaderWithCommercials,
  GeneralSummaryControl,
  VideoControl,
  TrajectoryControl,
  DispersionControl,
  MultiShotControl,
  ClubControl,
  ViewButton,
  ShareButtons,
  StrokesGroupButton,
  IDispersionControlProps,
  SpinnerEventHandlerArgs,
  IHeaderWithCommercialProps,
  NormalizedCheckboxText,
} from 'Components';
import { autorun, action } from 'mobx';
import { observer } from 'mobx-react';
import { TestReportStore } from './../Stores/TestReportStore';
import { tps } from '../../Tps/TpsCallback';
import * as ICombineTestReportProps from './ICombineTestReportProps';
import { ReportComponentState } from 'Reports/Helpers/models';
import { NormalizationSettingsType } from 'Components/NormalizationSettings/configs';

@observer
export class CombineTestReport extends React.Component<
  ICombineTestReportProps.ICombineTestReportProps,
  ReportComponentState
> /*BaseReport*/ {
  private reportDataService: IReportDataService = Injector.resolve<IReportDataService>(
    'IReportDataService'
  );
  private dataConversionService: IReportDataConversionService = Injector.resolve<
    IReportDataConversionService
  >('IReportDataConversionService');
  private subscriptions = new Array<any>();
  private reportStore: TestReportStore;
  private runCount = 1;
  private skipOneTimeHistoryPush = false;

  constructor(props: ICombineTestReportProps.ICombineTestReportProps) {
    super(props, undefined);
    this.reportStore = props.store;
    this.state = {
      isUpdatingReport: false,
    };
    tps.reportConfiguration(this.reportStore);
    this.loadDataToState(
      this.reportDataService,
      this.reportStore,
      this.props.spinnerEventHandler
    ).done(() => {
      //Url state has higher priority, so we overwrite.
      MultiShotHelpers.deserializeStateFromUrl(this.reportStore);

      this.subscriptions.push(
        autorun(() => {
          console.log(this.runCount++);
          if (this.skipOneTimeHistoryPush) {
            this.skipOneTimeHistoryPush = false;
            return;
          }

          const queryString = '?' + MultiShotHelpers.serializeStateToUrlQuery(this.reportStore);

          const pathName = window.location.pathname;
          const newUrl = pathName + queryString;
          window.history.pushState(this.reportStore.toReportConfiguration(), '', newUrl);
          this.reportStore.reportPrintUrl = newUrl + '&p=1&rfu';
          this.reportStore.currentUrl = newUrl;
          if (this.reportStore.isWeb) {
            this.reportStore.shareLink = window.location.origin + newUrl + '&rfu';
          }
        })
      );
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      window.addEventListener('popstate', (e: PopStateEvent) => {
        if (!e.state) {
          return;
        }
        if (!self) {
          console.error('no state');
        }
        const reportConfigs = e.state as Data.IReportConfiguration;
        self.skipOneTimeHistoryPush = true;
        self.reportStore.fromReportConfiguration(reportConfigs);
        self.reportStore.currentUrl = window.location.pathname + window.location.search;
      });
    });
    this.reportStore.showOptimizerTutorial = MultiShotHelpers.checkIfOptimizerTutorialShouldBeShown();
  }

  private loadDataToState(
    reportDataService: IReportDataService,
    reportStore: TestReportStore,
    spinnerEventHandler: EventEmitter<Record<string, any>, SpinnerEventHandlerArgs>
  ): Q.Promise<[Data.IMeasurementReport, boolean]> {
    const promise = MultiShotHelpers.loadDataToState(
      reportDataService,
      reportStore,
      spinnerEventHandler
    );
    promise.done((result: [Data.IMeasurementReport, boolean]) => {
      const [data] = result;
      const group = data.groups[0];
      const strokes = group?.strokes;
      const stroke = strokes && strokes[0];
      this.reportStore.testResult = data.testResult;
      if (stroke) {
        this.reportStore.ball = stroke.ball ? stroke.ball : '-';
        this.reportStore.player = group.player;
      }
    });
    return promise;
  }

  private getReportStore(): TestReportStore {
    return this.reportStore;
  }

  componentWillUnmount(): void {
    this.subscriptions.forEach(disposer => disposer());
  }

  componentWillReceiveProps() {
    this.setState({
      isUpdatingReport: false,
    });
  }

  @action.bound
  private onInstructorMessageChanged(message: string | undefined) {
    if (message) {
      this.reportStore.instructorMessage = message;
    }
  }
  @action.bound
  private onSelectedVideosChanged(videos: Data.IReportVideo[]) {
    MultiShotHelpers.onSelectedVideosChanged(videos, this.reportStore);
  }
  @action.bound
  private loadTiles(): void {
    MultiShotHelpers.loadTiles(this.reportStore);
  }
  @action.bound
  private addTile(param: string, visibleCount: number): boolean {
    return MultiShotHelpers.addTile(param, visibleCount, this.reportStore);
  }
  @action.bound
  private displayStrokesGroup(index: number) {
    MultiShotHelpers.displayStrokesGroup(index, this.reportStore, tps);
  }
  @action.bound
  private selectVideo(
    stroke: Data.IReportMeasurement,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    this.selectShot(stroke, measurementGroup);
    this.scrollToVideoComponent();
    this.reportStore.selectedView = Data.ViewType.Video;
  }
  @action.bound
  private hideOptimizerTutorial() {
    this.reportStore.showOptimizerTutorial = false;
  }
  @action.bound
  private selectOptimizerView(name: string) {
    if (name) {
      this.reportStore.selectedOptimizerView = Data.GetOptimizerView(name);
    }
  }
  @action.bound
  private selectOptimizedType(optimizedType: Data.IOptimizationType) {
    this.reportStore.selectedOptimizedType = optimizedType;
  }
  @action.bound
  private doNotShowOptimizerAgain() {
    MultiShotHelpers.setToDontShowOptimizerTutorial();
  }
  @action.bound
  private disableTile(index: number) {
    this.reportStore.measurementParameters[index].isVisible = false;
  }

  @action.bound
  private cleanSelectedShot() {
    MultiShotHelpers.cleanSelectedShot(this.reportStore);
  }

  @action.bound
  private selectShot(
    stroke: Data.IReportMeasurement,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    MultiShotHelpers.selectShot(stroke, measurementGroup, this.reportStore);
  }

  @action.bound
  private selectAverage(
    strokes: Array<Data.IReportMeasurement>,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    MultiShotHelpers.selectAverage(strokes, measurementGroup, this.reportStore);
  }

  @action.bound
  private collapseStrokesGroup(measurementGroup: Data.IReportMeasurementGroup) {
    measurementGroup.isCollapsed = !measurementGroup.isCollapsed;
  }
  //todo: no jquery
  private scrollToVideoComponent() {
    $('#view-buttons').ready(function() {
      $('html, body')
        .delay(300)
        .animate(
          {
            scrollTop: $('#view-buttons').offset()?.top,
          },
          2000
        );
    });
  }

  @action.bound
  private updateUnitOnTiles(): void {
    MultiShotHelpers.updateUnitOnTiles(this.reportStore);
  }
  @action.bound
  private onDispersionModeChange(mode: string | undefined) {
    if (mode) {
      this.reportStore.selectedDispersionMode = Data.GetDispersionMode(mode);
    }
  }
  @action.bound
  private onSelectedStrokeChange(stroke: Data.IReportMeasurement | undefined) {
    if (stroke) {
      this.reportStore.selectedStroke = stroke;
    }
  }
  @action.bound
  private onSelectedClubChange(club: string | undefined) {
    if (club) {
      this.reportStore.clubType = club;
    }
  }
  @action.bound
  private onSelectedGroupOfStrokesChange(strokeGroup: Data.IReportMeasurementGroup | undefined) {
    if (strokeGroup) {
      this.reportStore.selectedGroupOfStrokes = strokeGroup;
    }
  }
  @action.bound
  private onSelectedAverageChange(averange: Data.IReportMeasurement | undefined) {
    if (averange) {
      this.reportStore.selectedAverage = averange;
    }
  }
  @action.bound
  changeData() {
    this.reportStore.showNormalizedData = !this.reportStore.showNormalizedData;
  }
  @action.bound
  toggleNormalization(value: boolean) {
    this.reportStore.showNormalizedData = value;
    // this.setState({
    //   isUpdatingReport: true,
    // });
    // this.props.updateReportData?.();
    this.changeStrokesValues();
  }

  @action.bound
  setNormalizationSettings = (normalizationSettings: NormalizationSettingsType) => {
    this.reportStore.normalizationSettings = normalizationSettings;
    this.setState({
      isUpdatingReport: true,
    });
    this.props.updateReportData?.(normalizationSettings);
  };

  @action.bound
  onSelectStroke(group: Data.IReportMeasurementGroup, stroke: Data.IReportMeasurement) {
    MultiShotHelpers.onSelectStroke(group, stroke, this.reportStore);
  }

  @action.bound
  onCleanSelectedShot() {
    MultiShotHelpers.onCleanSelectedShot(this.reportStore);
  }

  @action.bound
  changeStrokesValues() {
    MultiShotHelpers.changeStrokesAccordingToIsNormalized(this.reportStore);
  }
  @action.bound
  private onClickMailButton() {
    MultiShotHelpers.onClickMailButton(this.reportStore);
  }

  @action.bound
  private shareOnTwitterOnClick() {
    MultiShotHelpers.shareOnTwitterOnClick(this.reportStore);
  }

  @action.bound
  private shareOnFacebookOnClick() {
    MultiShotHelpers.shareOnFacebookOnClick(this.reportStore);
  }

  render() {
    const isCombineOrTestCenterReport =
      this.reportStore.reportKind === Data.ReportKind.combineTestReport ||
      this.reportStore.reportKind === Data.ReportKind.testCenterReport;
    const isDisabledSummaryView =
      this.reportStore.editModeInTps && !this.reportStore.summaryOn ? 'disabled-view' : '';
    const isDisabledDispersionView =
      this.reportStore.editModeInTps && !this.reportStore.dispersionOn ? 'disabled-view' : '';
    const isDisabledTrajectoryView =
      this.reportStore.editModeInTps && !this.reportStore.trajectoryOn ? 'disabled-view' : '';
    const isDisabledClubDataView =
      this.reportStore.editModeInTps && !this.reportStore.clubDataOn ? 'disabled-view' : '';
    const isDisabledVideoView =
      this.reportStore.editModeInTps && !this.reportStore.videoOn ? 'disabled-view' : '';
    const isInEditModeInTps = this.reportStore.editModeInTps;

    //let isNormalizedCheckNotChecked = !this.reportStore.showNormalizedData ? 'glyphicon-unchecked' : 'glyphicon-check';

    return (
      this.reportStore.showReport && (
        <div className="combine-test-report">
          {
            <div>
              <div>
                <HeaderWithCommercials {...this.getHeaderWithCommercialProps()} />
              </div>
              <div className="visible-print-block report-printed-paragraph">
                <h1>TrackMan Combine</h1>
                <p>
                  The TrackMan Combine consists of 60 shots to 10 different targets from 60 yards
                  and up to driver shots.
                </p>
              </div>

              <div className="hidden-print">
                <div className={`${CombineTestReportStyle.individualPlayerShots} row`}>
                  {this.reportStore.individualPlayers.map(currentPlayer => {
                    return this.reportStore.measurementsData.map((measurementGroup, j) => {
                      if (
                        measurementGroup.player &&
                        measurementGroup.player.id === currentPlayer.id
                      ) {
                        return (
                          <StrokesGroupButton
                            reportKind={this.reportStore.reportKind}
                            key={measurementGroup.id}
                            measurementGroup={measurementGroup}
                            groupIndex={j}
                            displayStrokesGroup={this.displayStrokesGroup}
                            unitPresentation={this.reportStore.unitPresentation}
                            selectedUnit={this.reportStore.selectedUnit}
                            className=""
                          />
                        );
                      }
                      return null;
                    });
                  })}
                </div>
              </div>

              {/* {this.reportStore.reportKind === Data.ReportKind.testCenterReport && (
                <NormalizationSettings
                  disabled={this.state.isUpdatingReport}
                  isActive={this.reportStore.showNormalizedData}
                  setIsActive={this.toggleNormalization}
                  value={this.reportStore.normalizationSettings}
                  onChange={this.setNormalizationSettings}
                />
              )} */}

              <div id="view-buttons" className="row">
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.summaryOn) && isCombineOrTestCenterReport
                  }
                  view={Data.ViewType.Summary}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.Summary, this.reportStore)
                  }
                  classNameForViewButton="summary-tab"
                  enabled={this.reportStore.summaryOn}
                  buttonName="Summary"
                  buttonIconSelected=""
                  buttonIconNotSelected=""
                  selectedView={this.reportStore.selectedView}
                />

                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.dispersionOn) &&
                    isCombineOrTestCenterReport
                  }
                  view={Data.ViewType.Dispersion}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.Dispersion, this.reportStore)
                  }
                  classNameForViewButton="dispersion-tab"
                  enabled={this.reportStore.dispersionOn}
                  buttonName="Dispersion"
                  buttonIconSelected="Images/dispersion-icon-white.svg"
                  buttonIconNotSelected="Images/dispersion-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />

                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.trajectoryOn) &&
                    isCombineOrTestCenterReport
                  }
                  view={Data.ViewType.Trajectory}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.Trajectory, this.reportStore)
                  }
                  classNameForViewButton="trajectory-tab"
                  enabled={this.reportStore.trajectoryOn}
                  buttonName="Trajectory"
                  buttonIconSelected="Images/trajectory-icon-white.svg"
                  buttonIconNotSelected="Images/trajectory-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />

                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.clubDataOn) &&
                    isCombineOrTestCenterReport
                  }
                  view={Data.ViewType.ClubData}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.ClubData, this.reportStore)
                  }
                  classNameForViewButton="club-data-tab"
                  enabled={this.reportStore.clubDataOn}
                  buttonName="Club data"
                  buttonIconSelected="Images/club-data-icon-white.svg"
                  buttonIconNotSelected="Images/club-data-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
              </div>

              <div className="printed-first-page visible-print-block">
                <GeneralSummaryControl {...this.getGeneralSummaryControlProps()} />
                {this.reportStore.isWeb && (
                  <div className="visible-print-block sponsor-details">
                    <SponsorDetails {...this.getSponsorDetailsParameters()} />
                  </div>
                )}
              </div>
              <div className="printed-second-page visible-print-block">
                <h2 className="printed-page-title-text visible-print-block">
                  Average score per target
                </h2>
                <SummaryScreenControl {...this.getSummaryScreenControlPrintProps()} />
              </div>
              <div className="printed-third-page visible-print-block">
                <h2 className="printed-page-title-text">Dispersion & Trajectory</h2>
                <div className={`dispersion-control col-xs-12 ${isDisabledDispersionView}`}>
                  <DispersionControl {...this.getDispersionControlParametres()} />
                </div>
                <div className={isDisabledTrajectoryView}>
                  <TrajectoryControl {...this.getTrajectoryControlParameters()} />
                </div>
              </div>

              {this.reportStore.selectedView === Data.ViewType.Summary &&
                (this.reportStore.editModeInTps || this.reportStore.summaryOn) &&
                isCombineOrTestCenterReport && (
                  <div className={isDisabledSummaryView}>
                    <div className="hidden-print GeneralSummaryScreenControl">
                      <GeneralSummaryControl {...this.getGeneralSummaryControlProps()} />
                    </div>
                    <div className="hidden-print SummaryScreenControl">
                      <SummaryScreenControl {...this.getSummaryScreenControlDisplayProps()} />
                    </div>
                  </div>
                )}

              {this.reportStore.selectedView === Data.ViewType.Dispersion &&
                (this.reportStore.editModeInTps || this.reportStore.dispersionOn) &&
                isCombineOrTestCenterReport && (
                  <div
                    className={`dispersion-control col-xs-12 hidden-print ${isDisabledDispersionView}`}
                  >
                    <DispersionControl {...this.getDispersionControlParametres()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.Trajectory &&
                (this.reportStore.editModeInTps || this.reportStore.trajectoryOn) &&
                isCombineOrTestCenterReport && (
                  <div className={`trajectory-control hidden-print ${isDisabledTrajectoryView}`}>
                    <TrajectoryControl {...this.getTrajectoryControlParameters()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.ClubData &&
                (this.reportStore.editModeInTps || this.reportStore.clubDataOn) &&
                isCombineOrTestCenterReport && (
                  <div className={`hidden-print ${isDisabledClubDataView}`}>
                    <ClubControl {...this.getClubDataParameters()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.Video &&
                this.reportStore.reportHasAtLeastOneVideo &&
                (isInEditModeInTps || this.reportStore.videoOn) && (
                  <div className={`hidden-print ${isDisabledVideoView}`}>
                    <VideoControl {...this.getVideoParameters()} />
                  </div>
                )}
              <MultiShotControl {...this.getMultiShotControlParametres()} />
              {this.reportStore.reportKind === Data.ReportKind.testCenterReport && (
                <div className="normalized-data-check">
                  <NormalizedCheckboxText {...this.getNormalizedCheckboxText()} />
                </div>
              )}
              {this.reportStore.isWeb && <ShareButtons {...this.getShareButtons()} />}
            </div>
          }
          {this.reportStore.noStrokes && <ReportWithNoData />}
          {<FooterWithCommercial {...this.getFooterWithCommercial()} />}
        </div>
      )
    );
  }
  private getHeaderWithCommercialProps() {
    const result: IHeaderWithCommercialProps = {
      individualPlayers: this.reportStore.individualPlayers,
      reportDate: this.reportStore.reportDate,
      sponsors: this.reportStore.sponsors,
      facilities: this.reportStore.facilities,
      reportKind: this.reportStore.reportKind,
      isWeb: this.reportStore.isWeb,
      isTps: this.reportStore.isTps,
    };
    return result;
  }
  private getGeneralSummaryControlProps() {
    const result: IGeneralSummaryControlParams = {
      player: this.reportStore.player,
      testResult: this.reportStore.testResult,
      reportDate: this.reportStore.reportDate,
      ball: this.reportStore.ball,
      unitPresentation: this.reportStore.unitPresentation,
      reportKind: this.reportStore.reportKind,
    };
    return result;
  }

  private getSummaryScreenControlPrintProps() {
    const result: ISummaryScreenControlParams = {
      measurementGroups: this.reportStore.measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      ball: this.reportStore.ball,
      reportDate: this.reportStore.reportDate,
      testResult: this.reportStore.testResult,
      player: this.reportStore.player,
      idForGradient: 'printInstance',
      selectedUnit: this.reportStore.selectedUnit,
    };
    return result;
  }
  private getSummaryScreenControlDisplayProps() {
    const result: ISummaryScreenControlParams = {
      measurementGroups: this.reportStore.measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      ball: this.reportStore.ball,
      reportDate: this.reportStore.reportDate,
      testResult: this.reportStore.testResult,
      player: this.reportStore.player,
      idForGradient: 'screenInstance',
      selectedUnit: this.reportStore.selectedUnit,
    };
    return result;
  }

  private getShareButtons() {
    const result: IShareButtonsProps = {
      shareLink: this.reportStore.shareLink,
      reportKind: this.reportStore.reportKind,
      setShareLink: (link: string) => (this.reportStore.shareLink = link),
      onClickMailButton: this.onClickMailButton,
      shareOnTwitterOnClick: this.shareOnTwitterOnClick,
      shareOnFacebookOnClick: this.shareOnFacebookOnClick,
      reportPrintUrl: this.reportStore.reportPrintUrl,
    };
    return result;
  }
  private getFooterWithCommercial() {
    const result: IFooterWithCommercialProps = {
      showBottomCommercial: this.reportStore.showBottomCommercial,
      editModeInTps: this.reportStore.editModeInTps,
      isTps: this.reportStore.isTps,
    };
    return result;
  }

  private getNormalizedCheckboxText() {
    const result: INormalizedCheckboxTextProps = {
      reportKind: this.reportStore.reportKind,
      showNormalizedData: this.reportStore.showNormalizedData,
      normalizedEnvironmentDetails: this.reportStore.normalizedEnvironmentDetails,
      unitPresentation: this.reportStore.unitPresentation,
    };
    return result;
  }
  private getVideoParameters() {
    const result: IVideoControlProps = {
      videos: this.reportStore.videos,
      selectedVideos: this.reportStore.selectedVideos,
      showMultiGroupReport: true,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: this.reportStore.selectedAverage,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,
      isTps: this.reportStore.isTps,
      onSelectedVideosChanged: this.onSelectedVideosChanged,
    };
    return result;
  }
  private getTrajectoryControlParameters() {
    const result: ITrajectoryControlParams = {
      measurementsData: this.reportStore.measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      showNormalizedData: this.reportStore.showNormalizedData,
      selectedAverage: this.reportStore.selectedAverage,
      selectedClub: this.reportStore.clubType,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,
      onSelectStroke: this.onSelectStroke,
      onCleanSelectedShot: this.onCleanSelectedShot,
    };
    return result;
  }
  private getInstructorMessageParameters() {
    const result: IInstructorMessageControlProps = {
      instructorMessage: this.reportStore.instructorMessage,
      instructorImage: this.reportStore.instructorImage,
      instructorName: this.reportStore.instructorName,
      instructorId: this.reportStore.instructorId,
      isWeb: this.reportStore.isWeb,
      isTps: this.reportStore.isTps,
      onInstructorMessageChanged: this.onInstructorMessageChanged,
    };
    return result;
  }
  private getSponsorDetailsParameters() {
    const result: ISponsorDetailsProps = {
      sponsors: this.reportStore.sponsors,
      facilities: this.reportStore.facilities,
      isWeb: this.reportStore.isWeb,
      isTps: this.reportStore.isTps,
    };
    return result;
  }
  private getDispersionControlParametres() {
    const result: IDispersionControlProps = {
      measurementsData: this.reportStore.measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedAverage: this.reportStore.selectedAverage,
      selectedClub: this.reportStore.clubType,
      multiShotReportDataService: this.reportDataService,
      selectedDispersionMode: Data.GetDispersionMode(this.reportStore.selectedDispersionMode),
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,

      onDispersionModeChange: this.onDispersionModeChange,
      onSelectedStrokeChange: this.onSelectedStrokeChange,
      onSelectedClubChange: this.onSelectedClubChange,
      onSelectedGroupOfStrokesChange: this.onSelectedGroupOfStrokesChange,
      onSelectedAverageChange: this.onSelectedAverageChange,
    };
    return result;
  }
  private getOptimizerControlParametres() {
    const result: IOptimizerControlParams = {
      measurementsData: this.reportStore.selectedStroke,
      reportDataService: this.reportDataService,
      unitPresentation: this.reportStore.unitPresentation,
      clubType: this.reportStore.clubType,
      selectedStroke: this.reportStore.selectedStroke,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedAverage: this.reportStore.selectedAverage,
      selectedOptimizerView: this.reportStore.selectedOptimizerView,
      selectedView: this.reportStore.selectedView,
      selectedOptimizedType: this.reportStore.selectedOptimizedType,
      defaultOptimizedTypes: Data.DefaultOptimizedTypes,
      showNormalizedData: this.reportStore.showNormalizedData,
      reportId: this.reportStore.reportId,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      isTps: this.reportStore.isTps,
      isWeb: this.reportStore.isWeb,
      reportKind: this.reportStore.reportKind,
      showOptimizerTutorial: this.reportStore.showOptimizerTutorial,
      hideOptimizerTutorial: this.hideOptimizerTutorial,
      selectOptimizerView: this.selectOptimizerView,
      selectOptimizedType: this.selectOptimizedType,
      doNotShowOptimizerAgain: this.doNotShowOptimizerAgain,
    };
    return result;
  }
  private getClubDataParameters() {
    const result: IClubControlProps = {
      measurementsData: this.reportStore.selectedStroke,
      clubType: this.reportStore.clubType,
      unitPresentation: this.reportStore.unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: this.reportStore.selectedAverage,
      isTps: this.reportStore.isTps,
      isIos: this.reportStore.isIos,
      isWeb: this.reportStore.isWeb,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,
    };
    return result;
  }
  private getMultiShotControlParametres() {
    const unitPresentation = this.reportStore.unitPresentation;
    const measurementParameters = this.reportStore.measurementParameters;
    const selectedGroupOfStrokes = this.reportStore.selectedGroupOfStrokes;
    const selectedAverage = this.reportStore.selectedAverage;

    const result: IMultiShotControlParams = {
      reportKind: this.reportStore.reportKind,
      measurementsData: this.reportStore.measurementsData,
      unitPresentation: unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: selectedAverage,
      selectedGroupOfStrokes: selectedGroupOfStrokes,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      selectedClub: this.reportStore.clubType,
      tilesToDisplay: this.reportStore.tilesToDisplay,
      selectedView: this.reportStore.selectedView,
      showNormalizedData: this.reportStore.showNormalizedData,
      videos: this.reportStore.videos,
      individualPlayers: this.reportStore.individualPlayers,
      isTps: this.reportStore.isTps,
      isIos: this.reportStore.isIos,
      isWeb: this.reportStore.isWeb,
      multiShotReportDataService: this.reportDataService,
      measurementParameters: measurementParameters,
      sponsors: this.reportStore.sponsors,
      facilities: this.reportStore.facilities,
      cleanSelectedShot: this.cleanSelectedShot,
      selectShot: this.selectShot,
      selectVideo: this.selectVideo,
      disableTile: this.disableTile,
      selectAverage: this.selectAverage,
      collapseStrokesGroup: this.collapseStrokesGroup,
      loadTiles: this.loadTiles,
      updateUnitOnTiles: this.updateUnitOnTiles,
      addTile: this.addTile,
      displayStrokesGroup: this.displayStrokesGroup,
      selectedUnit: this.reportStore.selectedUnit,
      reportStore: this.reportStore,
    };
    return result;
  }

  private getSkidAndRollControlParametres() {
    let measurementsData;

    if (this.reportStore.selectedAverage) {
      measurementsData = this.reportStore.selectedAverage;
    } else if (this.reportStore.selectedStroke) {
      measurementsData = this.reportStore.selectedStroke;
    }

    const result: ISkidAndRollControlParams = {
      measurementsData: measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      clubType: this.reportStore.clubType,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: this.reportStore.selectedAverage,
      selectedView: this.reportStore.selectedView,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      isTps: this.reportStore.isTps,
      isWeb: this.reportStore.isWeb,
      reportKind: this.reportStore.reportKind,
      widthOfContainer: 1140,
      heightOfContainer: 554,
      containerMarginTop: 73,
      containerMarginBottom: 102,
      containerMarginLeft: 137,
      containerMarginRight: 136,
    };
    return result;
  }
}
